module.exports = __webpack_public_path__ + "media/assets/images/cba@3x-91e8a7e699bd8d219b87354bf65d0fe7.png";